import React from "react";
import './style.css';
import baseUrl from "./../../baseUrl";

const Footer = () => {
    return (
        <footer className="the-main-footer">
            <div className="section-contact-information">
                <div className="contact-internal">
                    <a href={`${baseUrl}news`} className="internal-link">
                        ข่าวสาร
                    </a>
                    <a href={`${baseUrl}career`} className="internal-link">
                        ร่วมงานกับเรา
                    </a>
                    <a href={`${baseUrl}land-purchase`} className="internal-link">
                        เสนอขายที่ดิน
                    </a>
                    <a href={`${baseUrl}contact`} className="internal-link">
                        ติดต่อเรา
                    </a>
                </div>
                <div className="contact-external">
                    <a href="https://www.facebook.com/APthai" target="_blank" rel="noreferrer" className="external-link">
                        FACEBOOK
                    </a>
                    <span className="symbol"> • </span>
                    <a  href="https://www.instagram.com/ap_thai" target="_blank" rel="noreferrer" className="external-link">
                        INSTAGRAM
                    </a>
                    <span className="symbol"> • </span>
                    <a  href="https://twitter.com/AP_Inspire" target="_blank" rel="noreferrer" className="external-link">
                        TWITTER
                    </a>
                    <span className="symbol">
                        •
                    </span>
                    <a href="https://www.youtube.com/user/apciti" target="_blank" rel="noreferrer" className="external-link">
                        YOUTUBE
                    </a>
                </div>
            </div>
            <div className="section-corporate-group">
                <div className="corporate-container">
                    <a target="_blank" href="http://www.smartservice.co.th" rel="noreferrer"className="logo">
                        <img alt="Smart logo" src="https://www.apthai.com/_nuxt/img/logo-smart.6ba5bb7.svg" lazy="loaded" />
                    </a>
                    <a target="_blank" href="http://www.bkkcitismart.com" rel="noreferrer" className="logo">
                        <img alt="Bangkok citismart logo" src="	https://www.apthai.com/_nuxt/img/logo-bangkok-citismart.003ea88.png" lazy="loaded" />
                    </a>
                </div>
                <hr className="divider" />
                <div className="phone-container">
                    <div className="phone">
                        <svg width="1em" height="1em" viewBox="0 0 24 25" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="phone-icon"><path d="M9.09 24.5732H14.94C19.95 24.5732 24 20.5232 24 15.4832V9.66324C24 4.62324 19.95 0.573242 14.91 0.573242H9.09C4.05 0.573242 0 4.62324 0 9.66324V15.5132C0 20.5232 4.05 24.5732 9.09 24.5732ZM6.21 5.73324C6.99 5.04324 7.77 5.61324 7.77 5.61324L9.96 7.77324C10.95 8.76324 9.93 9.66324 9.93 9.66324L8.94 10.6532C10.38 13.8632 13.95 15.7232 13.95 15.7232L15.27 14.4332C16.11 13.8932 16.65 14.5232 16.65 14.5232L18.87 16.6832C19.74 17.7932 18.78 18.4832 18.78 18.4832C17.37 20.1332 15.33 19.6832 15.33 19.6832C12.42 19.2632 9.81 16.9832 9.81 16.9832C4.98 12.7832 4.92 9.96324 4.92 9.96324C4.32 7.32324 6.21 5.73324 6.21 5.73324Z" fill="currentColor"></path></svg>
                        <a href="tel:1623" className="phone-link"> 1623 </a>
                    </div>
                </div>
                <hr className="divider" />
            </div>
            <div className="section-legal-agreement">
                <div className="content-container">
                    <span className="caption ap-company"> © AP (Thailand) Public Company Limited</span>
                    <div className="link-container">
                        <a href={`${baseUrl}terms-conditions`} className="caption link"> ข้อตกลงและเงื่อนไข </a>
                        <span className="caption symbol"> • </span>
                        <a href={`${baseUrl}privacy-policy`} className="caption link"> นโยบายความเป็นส่วนตัว</a>
                        <span className="caption symbol"> • </span>
                        <span className="caption link caption-span"> ตั้งค่าคุกกี้ </span>
                    </div>
                </div>
                <a target="_blank" href="https://www.thai-cac.com" rel="noopener" className="logo">
                    <img alt="CAC logo" src="https://www.apthai.com/_nuxt/img/logo-cac.9bd5ab0.svg" lazy="loaded" />
                </a>
            </div>
        </footer>
    );
}
export default Footer;